import React, { useState, useEffect, SyntheticEvent } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Admin from './admin/Admin';
import { watchAuthStatus, adminSignIn } from '../firebase/firebase';


import './admin.css';

const AdminLogin = () => {

   const [username, setUsername] = useState('');
   const [password, setPassword] = useState('');
   const [isLogged, setIsLogged] = useState(false);

   useEffect(() => {
      watchAuthStatus(changeIsLogged);
   }, []);

   function changeIsLogged(status: boolean) {
      setIsLogged(status)
   }

   function clickButton(e: SyntheticEvent) {
      e.preventDefault();
      adminSignIn(username, password, (err: any) => console.log(err));
      // setUsername('');
      setPassword('');
   }

   return isLogged ?
      <Admin /> :
      (
         <div className='al-container padd d-flex justify-content-center align-items-center'>
            <Jumbotron>
               <div className='admin-login'>
                  <h3>Oi Kalytinha linda!</h3>
                  <Form>
                     <Form.Group controlId='formBasicEmail'>
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                           as='input'
                           type='email' 
                           placeholder='Enter email' 
                           onChange={e => setUsername(e.currentTarget.value)}
                           value={username}   
                        />
                     </Form.Group>

                     <Form.Group controlId='formBasicPassword'>
                        <Form.Label>Password</Form.Label>
                        <Form.Control 
                           as='input'
                           type='password' 
                           placeholder='Password'
                           onChange={e => setPassword(e.currentTarget.value)}
                           value={password}
                        />
                     </Form.Group>
                     <Button variant="primary" type="submit" onClick={e => clickButton(e)}>
                        Submit
                     </Button>
                  </Form>
               </div>
            </Jumbotron>
         </div>
      )
}

export default AdminLogin
